module.exports = __webpack_public_path__ + "static/media/nadeem.c8bfebd1.PNG";